import type { Page, Pagination } from '@aigc/types';
import { mutationOptions, queryOptions } from '@tanstack/react-query';
import qs from 'qs';
import { http } from '../common/http-client';
import type {
  ArkAssetItemDto,
  AssetCreateInputDto,
  AssetDto,
  AssetUpdateInputDto,
} from './model';

// ========== AIGC 资产管理 CRUD ==========

export interface AssetQueryParams {
  name?: string;
  status?: string[];
}

export function queryAigcAssets(
  pagination: Pagination,
  queryParams?: AssetQueryParams,
) {
  return queryOptions({
    queryKey: [...queryAigcAssets.BASE_QUERY_KEY, pagination, queryParams],
    queryFn: async () => {
      return http
        .get('aigc-assets', {
          searchParams: qs.stringify(
            {
              page: pagination.page ?? 1,
              size: pagination.size ?? 100,
              name: queryParams?.name || undefined,
              status: queryParams?.status?.length
                ? queryParams.status
                : undefined,
            },
            { arrayFormat: 'repeat', skipNulls: true },
          ),
        })
        .json<Page<AssetDto>>();
    },
  });
}
queryAigcAssets.BASE_QUERY_KEY = ['AIGC资产', '部门资产列表'];

export const createAigcAssetMutation = mutationOptions({
  mutationKey: queryAigcAssets.BASE_QUERY_KEY,
  mutationFn: async (input: AssetCreateInputDto) => {
    return http.post('aigc-assets', { json: input }).json<AssetDto>();
  },
});

export function updateAigcAssetMutation(asset_id: string) {
  return mutationOptions({
    mutationKey: queryAigcAssets.BASE_QUERY_KEY,
    mutationFn: async (input: AssetUpdateInputDto) => {
      return http
        .patch(`aigc-assets/${asset_id}`, { json: input })
        .json<AssetDto>();
    },
  });
}

export function deleteAigcAssetMutation(asset_id: string) {
  return mutationOptions({
    mutationKey: queryAigcAssets.BASE_QUERY_KEY,
    mutationFn: async () => {
      return http.delete(`aigc-assets/${asset_id}`);
    },
  });
}

/**
 * 可复用的删除函数，组件层调用时传入 asset_id
 */
export const deleteAigcAsset = (asset_id: string) => {
  return http.delete(`aigc-assets/${asset_id}`);
};

// ========== 虚拟人像（系统资产 + 部门资产） ==========

export const querySystemAigcAssets = queryOptions({
  queryKey: ['AIGC资产', '系统资产列表'],
  queryFn: async () => {
    return http.get('aigc-assets/system').json<ArkAssetItemDto[]>();
  },
});
